import { useCallback } from "react";
import { Badge, Checkbox, Group, Text } from "@mantine/core";

export interface SlideInfo {
  id: string;
  number: string;
  stain?: {
    id: string;
    code: string;
    description: string;
  } | null;
  isControlSlide?: boolean;
}

interface MaterialPickerSlideRowProps {
  slide: SlideInfo;
  checked: boolean;
  onToggleSlide: (slideId: string) => void;
}

export default function MaterialPickerSlideRow({
  slide,
  checked,
  onToggleSlide,
}: MaterialPickerSlideRowProps) {
  const handleChange = useCallback(() => {
    onToggleSlide(slide.id);
  }, [onToggleSlide, slide.id]);

  return (
    <Checkbox
      label={
        <Group gap="xs">
          <Text size="sm">
            {`Slide ${slide.number}${
              slide.stain?.code ? ` (${slide.stain.code})` : ""
            }`}
          </Text>
          {slide.isControlSlide && (
            <Badge size="xs" variant="light" color="violet">
              Control
            </Badge>
          )}
        </Group>
      }
      size="sm"
      ml="lg"
      mb={4}
      checked={checked}
      onChange={handleChange}
    />
  );
}
